import React from 'react';

import Label from '../Label/Label';
import Switch from '../Switch/Switch';
import Description from '../Description/Description';

import styles from './SwitchField.module.css';
import { SYSTEM_MODES } from '@silverfort-nodelibs/common/utils/system-mode-config';
import { SettingsFeatureLock } from '../../LockedFeatures/SettingsFeatureLock';

const SwitchField = ({
    field,
    changed,
    disabled,
    children,
    marginTop = 'normal',
    systemMode,
    featureLockId = undefined,
    featureLockIsTabId = undefined
}) => {
    const switchStyles = [];
    if (marginTop === 'normal') {
        switchStyles.push(styles.SwitchInput);
    } else if (marginTop === 'large') {
        switchStyles.push(styles.SwitchInputLarge);
    } else if (marginTop === 'small') {
        switchStyles.push(styles.SwitchInputSmall);
    } else if (marginTop === 'array') {
        switchStyles.push(styles.SwitchInputArray);
    }

    const renderDescription = () => {
        const desc = systemMode === SYSTEM_MODES.SAAS && field.saas_desc ? field.saas_desc : field.desc;
        return (
            <div style={{ marginTop: '5px' }}>
                <Description value={desc} />
            </div>
        );
    };

    return (
        <div className={switchStyles.join(' ')}>
            <div className={styles.fieldsContainer}>
                {featureLockId ? (
                    <SettingsFeatureLock id={featureLockId} isTabId={!!featureLockIsTabId}>
                        <Switch {...field} disabled={disabled} changed={changed} />
                    </SettingsFeatureLock>
                ) : (
                    <Switch {...field} disabled={disabled} changed={changed} />
                )}
                <Label value={field.name} bold={false} />
                {children && <span className={styles.buttons}>{children}</span>}
            </div>
            {renderDescription()}
            {field.warning && <div className={styles.warningText}>{field.warning}</div>}
            {field.notification && <div className={styles.notificationText}>{field.notification}</div>}
        </div>
    );
};

export default React.memo(SwitchField);
